export const RESTRICTED_ALLOWED_EMAILS = [
  'nisha@cresence.skin',
  'daxil@cresence.skin',
  'daxil5@gmail.com',
];

